var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "form-row", attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架类型编号" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateNo", $$v)
                                },
                                expression: "queryCondition.mateNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架类型名称" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateName", $$v)
                                },
                                expression: "queryCondition.mateName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "query-btn-row" },
                  [
                    _c(
                      "el-col",
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("搜索"),
                        ]),
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "form-row", attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "BCM号" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.bcm,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "bcm", $$v)
                                },
                                expression: "queryCondition.bcm",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "材质" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                model: {
                                  value: _vm.queryCondition.material,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "material",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.material",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "1",
                                  attrs: { label: "铁", value: "铁" },
                                }),
                                _c("el-option", {
                                  key: "2",
                                  attrs: { label: "塑料", value: "塑料" },
                                }),
                                _c("el-option", {
                                  key: "3",
                                  attrs: { label: "铁+塑料", value: "铁+塑料" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.addOrEditMaterial },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.uploadTemplate },
              },
              [_vm._v("上传")]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.downloadTemplate },
              },
              [_vm._v("下载")]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            staticClass: "table",
            attrs: {
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { "show-overflow-tooltip": "", label: "料架类型编号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          staticClass: "a-link",
                          attrs: {
                            replace: "",
                            to: {
                              name: "material-rack-edit",
                              params: { no: scope.row.no },
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.no))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "name",
                label: "料架类型名称",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "bcm",
                label: "BCM号",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "color",
                label: "颜色",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "packageName",
                label: "包装类型名称",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "material",
                label: "材质",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "total",
                label: "装载量",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "attachment",
                label: "附件",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "updateTime",
                label: "更新日期",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "updateUser",
                label: "更新人",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: { layout: "prev, pager, next", total: _vm.total },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }